var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScannerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.778 3.3A2.478 2.478 0 003.3 5.778v2.666a.7.7 0 101.4 0V5.778A1.078 1.078 0 015.778 4.7h2.666a.7.7 0 100-1.4H5.778zm9.778 0a.7.7 0 000 1.4h2.666A1.078 1.078 0 0119.3 5.778v2.666a.7.7 0 101.4 0V5.778A2.478 2.478 0 0018.222 3.3h-2.666zM4.7 15.555a.7.7 0 10-1.4 0v2.667A2.478 2.478 0 005.778 20.7h2.666a.7.7 0 100-1.4H5.778A1.077 1.077 0 014.7 18.222v-2.667zm16 0a.7.7 0 10-1.4 0v2.667a1.078 1.078 0 01-1.078 1.078h-2.666a.7.7 0 100 1.4h2.666a2.478 2.478 0 002.478-2.478v-2.667zM8.889 7.597a.7.7 0 000 1.4h6.222a.7.7 0 100-1.4H8.89zM6.633 11.85a.7.7 0 01.7-.7h9.334a.7.7 0 110 1.4H7.333a.7.7 0 01-.7-.7zm2.256 2.856a.7.7 0 000 1.4h6.222a.7.7 0 100-1.4H8.89z",
    fill: "var(--icon-dark-gray)"
  })));
}
export default SvgScannerIcon;